import React from 'react';
import styled from 'styled-components';
import { TextInput, Form } from './../../controls';

const Wrapper = styled.div`
	h4 {
		padding-bottom: 0;
		margin-bottom: 0;
		padding-left: 6px;
  }
  p {
    color: #575757;
    font-size: 0.85em;
    line-height: 1.25em;
  }
`;

const SubmitButton = styled.button`
	border: none;
	background-color: #0798ff;
	color: #fff;
	border-radius: .5em;
  font-size: 1em;
  font-weight: bold;
	padding-left: 1em;
	padding-right: 1em;
	padding-bottom: .5em;
	padding-top: .5em;
	cursor: pointer;
	margin-left: 6px;
	${({disabled}) => disabled && 'opacity: .6;' }
	&:hover {
		opacity: .6;
	}
	&:focus {
		outline: none;
	}
`;

const Error = styled.p`
	color: red;
	font-size: .8em;
	margin: 0;
	padding: 0;
	padding-top: 6px;
`;

const CRM = ({ children }) => {
  if (process.env.REACT_APP_NOPRIVACY) return children;
  const url = "https://forbusiness.benenden.co.uk/l/482581/2019-06-18/np9dz";
  return (<form action={url} method='post'>{children}</form>);
};

const SubmitForm = ({ onChange, isLoading, onLoad, errorMessages = [], onSubmit, isDisabled, data = {}, isNoPrivacy }) => {
	const formFields = [
		{
      name: 'company',
			field: 'companyName',
			label: 'Company name',
			isShow: true
		},
		{
      name: 'name',
			field: 'yourName',
			label: 'Your name',
			isShow: !isNoPrivacy
		},
		{
      name: 'email',
      field: 'email',
      type: 'email',
			label: 'Your email address',
			isShow: !isNoPrivacy
		},
		{
      name: 'phone',
			field: 'phone',
			label: 'Phone number',
			isShow: !isNoPrivacy
		}
	];

	const onSubmitForm = async () => {
		onLoad(true);
		await onSubmit();
		onLoad(false);
	};
	return (
		<Wrapper>
      <CRM>
        <h4>Download your personalised report</h4>
        <Form.Wrapper>
        {
          formFields.map(({ name, type, field, label, isShow }) => {
            if (!isShow) return null;
            return (
              <Form.Row key={field} >
                <TextInput
                  name={name}
                  type={type}
                  value={(data.submitForm || {})[field] || ''}
                  width='100%'
                  placeholder={label}
                  onChange={value => (onChange({ ...data, submitForm: { ...data.submitForm, [field]: value } }))}
                />
                {
                  errorMessages.map((error, index) => (error[field] ? (<Error key={index} >{Object.values(error)}</Error>) : null))
                }
              </Form.Row>
            )
          })
        }
        </Form.Wrapper>
        <SubmitButton disabled={isDisabled} onClick={!isDisabled ? onSubmitForm : () => {}} >{isLoading ? '... Downloading' : 'Submit'}</SubmitButton>
      </CRM>
			{ !isNoPrivacy && <p>Please note, your details will be passed on to our sales team who will contact you about our business products.
				You can opt out at any time by unsubscribing in any of our emails. <a href='/' >Our Privacy Policy</a>.</p>}
		</Wrapper>
	);
};

export default SubmitForm;



// WEBPACK FOOTER //
// ./src/html/components/Calculator/SubmitForm.js